import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { detectMixin } from '../helpers';

@Component
export default class RightsAware extends Vue {

  @Prop({default: false}) readonly readonly!: boolean;

  protected readonly_: boolean = false;

  @Watch("readonly")
  protected onReadonlyPropChange() {
    this.readonly_ = this.readonly;
  }

  get isReadonly() {
    for (let p = this.$parent; p; p = p && p.$parent) {
      if (detectMixin(p, RightsAware)) {
        return this.readonly_ || (p as RightsAware).isReadonly;
      }
    }
    return this.readonly_;
  }

  created() {
    this.readonly_ = this.readonly;
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-aee5d774/rights-aware.tsx" });